<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Terms & Conditions
            </h1>

        </div>
    </div>
</div>

<div class="el-blog-single-wrapper">
    <div class="container">
        <div class="row gy-4">
            <div class="col-lg-12 col-md-12">

                <div class="el-inner-blog-box el-blogsingle-comment-box el-blgs-comments-wrapper">

                    <div class="el-blgs-comments">


                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>By accessing PowerPerp’s website or apps, you agree to abide by the following terms:
                                </h5>

                            </div>
                            <div class="el-blgs-cmt-name">
                                <h5>1. Registration and Communication


                                </h5>

                            </div>
                            <p class="el-para">Creating an account is free and enables access to various features. By
                                registering, you consent to receiving
                                newsletters, product updates, and promotional communications via email and SMS.
                            </p>

                        </div>
                    </div>

                    <div class="el-blgs-comments">


                        <div class="el-blgs-cmts">

                            <div class="el-blgs-cmt-name">
                                <h5>2. Account Validity


                                </h5>

                            </div>
                            <p class="el-para">Your account will remain valid until the end of the current academic
                                year, i.e., 31st March, after which renewal or
                                re-registration may be required to continue access.
                            </p>

                        </div>
                    </div>

                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>3. Content Ownership and Use

                                </h5>

                            </div>
                            <p class="el-para">All materials on PowerPerp—including digital books, assessments, or AI
                                tools—are copyrighted. Redistribution,
                                duplication, or modification without written consent is prohibited.


                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts ">
                            <div class="el-blgs-cmt-name">
                                <h5>4. Digital Product Responsibility

                                </h5>

                            </div>
                            <p class="el-para">Ensure your device meets the required specifications before purchasing
                                digital content. We are not liable for refunds if
                                incompatibility or usage limitations are discovered post-purchase.


                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>5. Modifications and Promotions


                                </h5>

                            </div>
                            <p class="el-para">PowerPerp reserves the right to change, update, or discontinue products,
                                offers, and discounts at its discretion.
                                Promotional offers may be time-bound and subject to availability.


                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>6. User Conduct



                                </h5>

                            </div>
                            <p class="el-para">Users are expected to maintain respectful communication. Inappropriate or
                                offensive content may be removed without
                                notice.


                            </p>

                        </div>
                    </div>


                </div>

            </div>

        </div>
    </div>
</div>